import { jsx as a, jsxs as l, Fragment as Ie } from "react/jsx-runtime";
import i, { createContext as Le, useEffect as E, useCallback as Ne } from "react";
import { useJsApiLoader as Te } from "@react-google-maps/api";
import { useCenterMarker as Ee, useMarkerCluster as Se, convertSvgToUrl as re, generateAddress as ie, findOverlappingMarkers as se, useMapControls as _e, resetMarkerToCenter as De } from "./hooks.js";
import { renderToString as S } from "react-dom/server";
import le from "./RadioPin.js";
import { GOOGLE_MAPS_LIBRARIES as Re, GOOGLE_MAPS_LOADER_ID as ke } from "../../../config/googleMaps.js";
import { isEqual as ce } from "lodash";
const Ae = "data:image/svg+xml,%3csvg%20width='26'%20height='26'%20viewBox='0%200%2026%2026'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20opacity='0.3'%20cx='13'%20cy='12'%20r='12'%20fill='%236393F2'/%3e%3cg%20filter='url(%23filter0_d_11_548)'%3e%3ccircle%20cx='13'%20cy='12'%20r='5'%20fill='%236393F2'/%3e%3ccircle%20cx='13'%20cy='12'%20r='6'%20stroke='white'%20stroke-width='2'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='filter0_d_11_548'%20x='0'%20y='0'%20width='26'%20height='26'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='1'/%3e%3cfeGaussianBlur%20stdDeviation='3'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.15%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow_11_548'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow_11_548'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", de = {
  // name: "20972 Saratoga Hills Rd, Saratoga, CA 95070, USA",
  lat: 37.26534961208239,
  lng: -122.04076419999998
};
let F = [], W = [], U;
const pe = Le(void 0), We = () => {
  const _ = i.useContext(pe);
  if (_ === void 0)
    throw new Error("useMapContext must be used within a MapProvider");
  return _;
}, Ue = ({
  children: _,
  ...H
}) => {
  const {
    isLoaded: $
  } = Te({
    id: ke,
    googleMapsApiKey: H.apiKey,
    libraries: Re
  }), [t, ue] = i.useState(void 0), k = i.useRef(void 0), I = i.useRef(void 0), {
    center: v,
    zoom: L,
    showCurrentLocation: J,
    showCenterMarker: ge = !1,
    mapDraggable: fe = !0,
    markers: m,
    getMarkerData: A,
    onMarkerClick: B,
    onMarkerHover: O,
    onMarkerHoverLeave: Z,
    enableCluster: me = !1,
    selectedID: c,
    markerDraggable: K = !0,
    overrideDrag: X = !0,
    mapType: he = "roadmap",
    hideTooltip: Q = !1,
    getMapData: V,
    circles: b = [],
    showResetControl: ve = !1,
    showMetaDataTooltip: Y = !0,
    doNotGenerateAddress: ee = !1,
    setMapType: xe
  } = H, [h, q] = i.useState(v ?? de), [D, te] = i.useState(L ?? 10), [M, oe] = i.useState([]), [we, ne] = i.useState([]), [y, be] = i.useState(void 0), ae = i.useRef(V);
  ae.current = V, E(() => {
    t && (F = [], W = [], U = void 0, oe([]), ne([]), I.current = t);
  }, [t]);
  const N = i.useRef(null);
  E(() => {
    t && (v?.lat !== h.lat || v.lng !== h.lng) && q(v ?? de);
  }, [v, t]), E(() => {
    !t || L === void 0 || L !== D && te(L);
  }, [L, t]), Ee(ge, t, h, q);
  const G = Se(me, t, M), P = Ne(() => {
    navigator.geolocation && navigator.geolocation.getCurrentPosition((r) => {
      be({
        lat: r.coords.latitude,
        lng: r.coords.longitude
      });
    });
  }, []);
  i.useEffect(() => {
    if (!J) return;
    P();
    const r = setInterval(() => {
      P();
    }, 6e4);
    return () => clearInterval(r);
  }, [P, J]), i.useEffect(() => {
    y && t && new google.maps.Marker({
      position: y,
      map: t,
      title: "Current Location",
      icon: {
        url: Ae,
        scaledSize: new google.maps.Size(30, 30),
        anchor: new google.maps.Point(15, 15)
      }
    });
  }, [y, t]);
  const d = i.useMemo(() => t ? new google.maps.InfoWindow({
    content: "",
    headerDisabled: !0,
    maxWidth: 450,
    minWidth: 250
  }) : null, [t]);
  i.useEffect(() => {
    t && m && d && (async () => {
      const {
        AdvancedMarkerElement: r
      } = await google.maps.importLibrary("marker");
      if (I.current === t && ce(F, m) && U === c) return;
      M.forEach((e) => {
        google.maps.event.clearInstanceListeners(e), e.map = null;
      });
      const o = m.map((e) => {
        const g = c ? c === e.id : K, T = re(/* @__PURE__ */ a(le, { type: e.radioType, parameters: {
          angle: 0,
          beamwidth: 0,
          gain: 30,
          health: "GOOD",
          channelColor: "#34A853",
          network: "4G"
        } })), ye = re(/* @__PURE__ */ a(le, { type: e.radioType, parameters: {
          angle: 0,
          beamwidth: 0,
          gain: 30,
          health: "NA",
          channelColor: "#9E9E9E",
          network: "4G"
        } })), R = g ? T : ye, f = document.createElement("div");
        f.style.position = "relative", f.style.display = "flex", f.style.flexDirection = "column", f.style.alignItems = "center", f.style.overflow = "hidden";
        const x = document.createElement("img");
        if (x.src = e.icon ?? R, x.style.width = c === e.id ? "80px" : "60px", x.style.height = c === e.id ? "80px" : "60px", x.alt = e.title || e.label || "", x.style.display = "block", e.label) {
          const n = document.createElement("div");
          n.textContent = e.label, n.style.cssText = `
            background-color: rgba(0, 0, 0, 0.8);
            color: white;
            padding: 2px 6px;
            border-radius: 3px;
            font-size: 10px;
            font-weight: bold;
            font-family: Arial, sans-serif;
            margin-top: 2px;
            white-space: nowrap;
            text-align: center;
          `, f.appendChild(x), f.appendChild(n);
        } else
          f.appendChild(x);
        if (e.badge) {
          const n = document.createElement("div");
          n.textContent = e.badge.text, n.style.cssText = `
            position: absolute;
            bottom: 2px;
            left: 50%;
            transform: translateX(-50%);
            min-width: 18px;
            height: 18px;
            border-radius: 9px;
            background-color: ${e.badge.color ?? "#1976d2"};
            color: ${e.badge.textColor ?? "white"};
            font-size: 10px;
            font-weight: bold;
            font-family: Arial, sans-serif;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 4px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.3);
            pointer-events: none;
          `, f.appendChild(n);
        }
        const p = new r({
          position: e.location,
          title: e.title || e.label,
          map: t,
          content: f,
          gmpDraggable: X ? g : !1,
          zIndex: g ? 1e3 : void 0
        });
        return Object.defineProperty(p, "markerId", {
          value: e.id,
          writable: !1
        }), Object.defineProperty(p, "metadata", {
          value: e.metadata,
          writable: !1
        }), c === e.id && (k.current = p), p.addListener("dragend", async () => {
          const n = p.position, w = typeof n?.lat == "function" ? n.lat() : n?.lat, s = typeof n?.lng == "function" ? n.lng() : n?.lng;
          if (!w || !s) {
            console.error("Invalid marker position at marker instance dragend:", n);
            return;
          }
          const u = await ie(w, s), C = {
            id: e.id,
            location: {
              lat: w,
              lng: s,
              address: u
            }
          };
          A?.(C);
        }), p.addListener("click", () => {
          if (!B) return;
          const n = se(p, o, t), w = m.filter((s) => n.some((u) => u.markerId === s.id));
          B(e, w, c === e.id);
        }), p.content?.addEventListener("mouseenter", () => {
          if (Q) return;
          const n = se(p, o, t);
          if (n.length > 0) {
            const s = n.slice(0, 6), u = n.length - s.length;
            d.setContent(S(/* @__PURE__ */ l("div", { className: "map-tooltip-div", children: [
              /* @__PURE__ */ l("div", { className: "tooltip-subtitle", children: [
                "Multiple at this location (",
                n.length + 1,
                ")"
              ] }),
              /* @__PURE__ */ l("ul", { className: "overlapping-markers", children: [
                /* @__PURE__ */ l("li", { className: "overlapping-marker", children: [
                  /* @__PURE__ */ a("img", { src: e.icon ?? R, alt: e.title, className: "tooltip-icon" }),
                  /* @__PURE__ */ a("span", { children: e.title })
                ] }),
                s.map((C, z) => {
                  const j = m.find((Ce) => C.markerId === Ce.id);
                  return /* @__PURE__ */ l("li", { className: "overlapping-marker", children: [
                    /* @__PURE__ */ a("img", { className: "tooltip-icon", src: j?.icon ?? R, alt: j?.title }),
                    /* @__PURE__ */ a("span", { children: j?.title })
                  ] }, z);
                }),
                u > 0 && /* @__PURE__ */ a("li", { className: "overlapping-marker more-markers", children: /* @__PURE__ */ l("span", { children: [
                  "+",
                  u,
                  " more"
                ] }) })
              ] })
            ] })));
          } else e.tooltipRender ? d.setContent(S(/* @__PURE__ */ a("div", { className: "map-tooltip-div", children: e.tooltipRender(e, n) }))) : d.setContent(S(/* @__PURE__ */ l("div", { className: "map-tooltip-div", children: [
            /* @__PURE__ */ l("div", { className: "tooltip-header", children: [
              /* @__PURE__ */ a("img", { src: e.icon ?? R, alt: e.title, className: "tooltip-icon" }),
              /* @__PURE__ */ a("div", { children: /* @__PURE__ */ a("div", { className: "tooltip-title", children: e.title }) })
            ] }),
            Y && /* @__PURE__ */ l("div", { children: [
              /* @__PURE__ */ a("div", { className: "tooltip-section-title", children: "Details" }),
              Array.isArray(e.metadata) ? e.metadata.map((s, u) => /* @__PURE__ */ a("div", { className: "tooltip-data-card", children: /* @__PURE__ */ a("div", { className: "tooltip-data-grid", children: Object.entries(s).map(([C, z]) => /* @__PURE__ */ l("div", { children: [
                /* @__PURE__ */ l("span", { className: "tooltip-data-label", children: [
                  C,
                  ":"
                ] }),
                " ",
                /* @__PURE__ */ a("span", { className: "tooltip-data-value", children: z })
              ] }, C)) }) }, u)) : /* @__PURE__ */ a("div", { className: "tooltip-data-card", children: /* @__PURE__ */ a("div", { className: "tooltip-data-grid", children: Object.entries(e.metadata ?? {}).map(([s, u]) => /* @__PURE__ */ l("div", { children: [
                /* @__PURE__ */ l("span", { className: "tooltip-data-label", children: [
                  s,
                  ":"
                ] }),
                " ",
                /* @__PURE__ */ a("span", { className: "tooltip-data-value", children: u })
              ] }, s)) }) })
            ] })
          ] })));
          if (d.open({
            anchor: p
          }), !O) return;
          const w = m.filter((s) => n.some((u) => u.markerId === s.id));
          O(e, w, c === e.id);
        }), p.content?.addEventListener("mouseleave", () => {
          d.close(), Z?.();
        }), p;
      });
      oe(o), F = m, U = c, I.current = t;
    })();
  }, [$, t, K, m, X, c, b, Q, Y, d, A, B, O, Z]), i.useEffect(() => {
    if (!t || !b || !d || I.current === t && ce(W, b)) return;
    we.forEach((o) => {
      const e = o.get("text");
      e && (google.maps.event.clearInstanceListeners(e), e.setMap(null)), google.maps.event.clearInstanceListeners(o), o.setMap(null);
    });
    const r = b.map((o) => {
      const e = new google.maps.Circle({
        map: t,
        center: o.center,
        radius: o.radius,
        fillColor: o.color,
        strokeColor: o.color,
        fillOpacity: 0.4
      }), g = new google.maps.Marker({
        position: o.center,
        map: t,
        label: {
          text: o.count?.toString() ?? "",
          fontSize: "16px",
          fontWeight: "500",
          color: "#fff"
        },
        icon: {
          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <circle cx="15" cy="15" r="13.5" fill="${o.color}" stroke="white" stroke-width="3"/>
              </svg>`)}`
        },
        zIndex: 1e3
      });
      return e.addListener("mouseover", () => {
        d.setContent(S(/* @__PURE__ */ a("div", { className: "map-tooltip-div", style: {
          padding: "6px",
          marginBottom: "10px"
        }, children: o.tooltipRender?.(o) }))), d.open({
          anchor: g
        });
      }), e.addListener("mouseout", () => {
        d.close();
      }), e.set("text", g), e;
    });
    ne(r), W = b, I.current = t;
  }, [t, b, d]);
  function Me() {
    const r = [], o = document.createElement("div"), e = S(/* @__PURE__ */ a(Ie, { children: /* @__PURE__ */ a("button", { className: "custom-map-control-button", title: "Reset to Center", children: /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", height: "16px", width: "16px", viewBox: "0 -960 960 960", fill: "#000", children: /* @__PURE__ */ a("path", { d: "M480-400q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0 280q-139 0-241-91.5T122-440h82q14 104 92.5 172T480-200q117 0 198.5-81.5T760-480q0-117-81.5-198.5T480-760q-69 0-129 32t-101 88h110v80H120v-240h80v94q51-64 124.5-99T480-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-120Z" }) }) }) }));
    return o.onclick = () => {
      t && De(t, k.current, c, A);
    }, o.innerHTML = e, m?.length && c && ve && r.push(o), r;
  }
  return _e(t, Me()), E(() => {
    if (t && M?.length > 1 && !v) {
      const r = new google.maps.LatLngBounds();
      M.forEach((o) => {
        const e = o.position, g = typeof e?.lat == "function" ? e.lat() : e?.lat, T = typeof e?.lng == "function" ? e.lng() : e?.lng;
        if (!g || !T) {
          console.error("Invalid marker position at map fit bounds:", o);
          return;
        }
        g !== 0 && T !== 0 && r.extend(new google.maps.LatLng(g, T));
      }), t.fitBounds(r), G.current?.clearMarkers(), G.current?.addMarkers(M);
    }
  }, [t, v, G, M]), E(() => {
    if (t)
      return N.current && clearTimeout(N.current), N.current = setTimeout(async () => {
        if (ee) return;
        const r = await ie(h.lat, h.lng), o = t.getBounds();
        ae.current?.({
          center: h,
          zoom: D,
          currentLocation: y,
          address: r,
          boundingBox: o ? {
            northWestBound: o.getNorthEast().toJSON(),
            southEastBound: o.getSouthWest().toJSON()
          } : void 0
        });
      }, 100), () => {
        N.current && clearTimeout(N.current);
      };
  }, [h, D, y, t, ee]), /* @__PURE__ */ a(pe.Provider, { value: {
    isAPIloaded: $,
    center: h,
    setCenter: q,
    zoom: D,
    setZoom: te,
    mapRef: t,
    setMapRef: ue,
    selectedMarkerInstance: k,
    mapDraggable: fe,
    currentLocation: y,
    mapType: he,
    handleMapTypeChange: () => {
      xe?.(t?.getMapTypeId());
    }
  }, children: _ });
};
export {
  Ue as MapProvider,
  We as useMapContext
};
